const styles = theme => ({
  root: {
    flexGrow: 1,
    alignItems: 'center',
  },
  textCenter: {
    textAlign: 'center',
  },
  disclaimer: {
    padding: '12px',
    background: '#af5700',
    marginBottom: '2rem',
    fontWeight: 900,
    color: '#ffffff',
    borderRadius: '8px'
  },
});

export default styles;
